import EzModalController from 'layouts/modal/modal-controller';
import { getAjaxModal } from 'lib/ajax-helpers';

export default class EmailVerificationModalController extends EzModalController {
  static targets = [
    'continueLink',
  ];

  connect() {
    super.connect();

    this.flagLoaded();
  }

  disconnect() {
    super.disconnect();
  }

  close = (event) => {
    super.close(event, () => {}, this.surveyAfterUserClose);
  }

  surveyAfterUserClose = () => {
    getAjaxModal(this.continueLinkTarget.getAttribute('href'));
  }
}
